import { inject } from "@angular/core";
import { CanActivateFn, Routes } from "@angular/router";
import { OktaAuthGuard } from "@okta/okta-angular";
import { OktaCallbackComponent } from "./core/auth/okta-callback.component";
import { AccessDeniedComponent } from "./core/auth/access-denied.component";
import { loginHintGuard } from "./core/auth/login-hint.guard";
import {
  accessDeniedGuard,
  entitlementGuard,
} from "./core/auth/entitlement.guard";
import { isE2EBypassActive } from "./core/auth/e2e-bypass";

/** Okta guard with an E2E-bypass short-circuit. Inert in production. */
const oktaOrBypassGuard: CanActivateFn = (route, state) => {
  if (isE2EBypassActive()) return true;
  return inject(OktaAuthGuard).canActivate(route, state);
};

export const APP_ROUTES: Routes = [
  // Modern path. Update the Okta app's redirect URI to this and remove
  // the legacy alias below once the Okta tenant is migrated.
  {
    path: "login/callback",
    component: OktaCallbackComponent,
  },
  // Legacy path — kept as an alias so existing Okta-issued redirects keep
  // working during the migration.
  {
    path: "implicit/callback",
    component: OktaCallbackComponent,
  },
  {
    path: "access-denied",
    canActivate: [accessDeniedGuard],
    component: AccessDeniedComponent,
  },
  {
    path: "admin",
    canActivate: [oktaOrBypassGuard, entitlementGuard],
    loadChildren: () =>
      import("./pages/pages.routes").then((m) => m.PAGES_ROUTES),
  },
  { path: "", pathMatch: "full", canActivate: [loginHintGuard], children: [] },
  { path: "**", redirectTo: "admin" },
];
